export const PER_PAGE = 50;
export const TOKEN_COOKIE_CONFIG = {
  secure: true,
  sameSite: "strict",
  expires: 7, // days — keep session for a week (was session cookie → logout on browser close)
};

export const API_URL = import.meta.env.VITE_API_URL || 'https://kernel.gitwork.tech/api/v1';
export const REVERB_APP_KEY = import.meta.env.VITE_REVERB_APP_KEY || 'reverb-kernel';
export const REVERB_HOST = import.meta.env.VITE_REVERB_HOST || 'kernel.gitwork.tech';
export const REVERB_PORT = import.meta.env.VITE_REVERB_PORT || 8082;
export const REVERB_TLS = import.meta.env.VITE_REVERB_TLS || false;

export const CAMPAIGN_STATUS = [
  { value: 0, name: 'Draft' },
  { value: 1, name: 'Pulished' },
  { value: 2, name: 'Archived' },
  { value: 3, name: 'Completed' }
];

export const TIMEZONES = [
  { label: "Pacific/Midway UTC -11:00", value: "UTC -11:00" },
  { label: "America/Adak UTC -10:00", value: "UTC -10:00" },
  { label: "Pacific/Marquesas UTC -09:30", value: "UTC -09:30" },
  { label: "America/Anchorage UTC -09:00", value: "UTC -09:00" },
  { label: "America/Los_Angeles UTC -08:00", value: "UTC -08:00" },
  { label: "America/Denver UTC -07:00", value: "UTC -07:00" },
  { label: "America/Chicago UTC -06:00", value: "UTC -06:00" },
  { label: "America/New_York UTC -05:00", value: "UTC -05:00" },
  { label: "America/Caracas UTC -04:30", value: "UTC -04:30" },
  { label: "America/Santiago UTC -04:00", value: "UTC -04:00" },
  { label: "America/St_Johns UTC -03:30", value: "UTC -03:30" },
  { label: "America/Argentina/Buenos_Aires UTC -03:00", value: "UTC -03:00" },
  { label: "Atlantic/South_Georgia UTC -02:00", value: "UTC -02:00" },
  { label: "Atlantic/Azores UTC -01:00", value: "UTC -01:00" },
  { label: "Europe/London UTC +00:00", value: "UTC +00:00" },
  { label: "Europe/Paris UTC +01:00", value: "UTC +01:00" },
  { label: "Europe/Athens UTC +02:00", value: "UTC +02:00" },
  { label: "Asia/Baghdad UTC +03:00", value: "UTC +03:00" },
  { label: "Asia/Tehran UTC +03:30", value: "UTC +03:30" },
  { label: "Asia/Dubai UTC +04:00", value: "UTC +04:00" },
  { label: "Asia/Kabul UTC +04:30", value: "UTC +04:30" },
  { label: "Asia/Karachi UTC +05:00", value: "UTC +05:00" },
  { label: "Asia/Kolkata UTC +05:30", value: "UTC +05:30" },
  { label: "Asia/Kathmandu UTC +05:45", value: "UTC +05:45" },
  { label: "Asia/Dhaka UTC +06:00", value: "UTC +06:00" },
  { label: "Asia/Yangon UTC +06:30", value: "UTC +06:30" },
  { label: "Asia/Bangkok UTC +07:00", value: "UTC +07:00" },
  { label: "Asia/Shanghai UTC +08:00", value: "UTC +08:00" },
  { label: "Australia/Eucla UTC +08:45", value: "UTC +08:45" },
  { label: "Asia/Tokyo UTC +09:00", value: "UTC +09:00" },
  { label: "Australia/Darwin UTC +09:30", value: "UTC +09:30" },
  { label: "Australia/Sydney UTC +10:00", value: "UTC +10:00" },
  { label: "Australia/Lord_Howe UTC +10:30", value: "UTC +10:30" },
  { label: "Pacific/Noumea UTC +11:00", value: "UTC +11:00" },
  { label: "Pacific/Auckland UTC +12:00", value: "UTC +12:00" },
  { label: "Pacific/Chatham UTC +12:45", value: "UTC +12:45" },
  { label: "Pacific/Tongatapu UTC +13:00", value: "UTC +13:00" },
  { label: "Pacific/Kiritimati UTC +14:00", value: "UTC +14:00" }
];



export const googleFontsApiKey = import.meta.env.VITE_GOOGLE_FONTS_API_KEY